import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { MobileTooltip } from './';
import Checkbox from '../../../../../common/Checkbox';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { canUserViewAppointmentContactInfo, fullName } from '../../../../../common/helpers/users';
import { maskEmail, maskPhoneNumber } from '../../../../../common/helpers/mask';

const DuplicateCustomer = ({ customer, checked, onChange, disabled, isMobileCustomer, permissions }) => (
  <div className={cx('c-table-card__row', { 'u-opacity': disabled })}>
    <div className="c-table-card__cell u-1/3">
      <MobileTooltip display-if={isMobileCustomer && !checked}>
        <span className="c-checkbox__text">
          {fullName(customer)}
        </span>
      </MobileTooltip>
      <Checkbox
        display-if={!isMobileCustomer || checked}
        small
        className="c-checkbox--small u-align-middle u-mr-"
        label={fullName(customer)}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
    <div className="c-table-card__cell u-1/3">
      <div className="u-type--underline">
        {!canUserViewAppointmentContactInfo(permissions) ? maskEmail(customer.email) : customer.email}
      </div>
    </div>
    <div className="c-table-card__cell u-1/3">
      <div>
        {!canUserViewAppointmentContactInfo(permissions) ? maskPhoneNumber(customer.phone) : customer.phone}
      </div>
    </div>
  </div>
);

DuplicateCustomer.propTypes = {
  customer: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isMobileCustomer: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
};

DuplicateCustomer.defaultProps = {
  onChange: () => null,
};

export default withPermissions(DuplicateCustomer);
